// بوابات ما قبل التصوير: أي بوابة مقفلة تمنع الكاميرا من الفتح إطلاقاً.
const failed = (checks, key) => checks.find((c) => c.key === key && !c.passed);

export const gateOf = (readiness, onQrCode) => {
  const checks = readiness?.checks || [];
  const absent = checks.find(
    (c) => !c.passed && c.absent_marked && (c.key === "time" || c.key === "checkout_window")
  );
  if (absent) return { kind: "absent", check: absent };
  const early = failed(checks, "early_window");
  if (early) return { kind: "early", check: early };
  const offDay = failed(checks, "workday");
  if (offDay) return { kind: "offDay", check: offDay };
  // النطاق الجغرافي شرط أساسي قبل QR: خارج النطاق لا تُفتح شاشة QR إطلاقاً.
  const geo = failed(checks, "geofence");
  if (geo) return { kind: "geo", check: geo };
  if (onQrCode && failed(checks, "qr")) return { kind: "qr" };
  return { kind: null };
};

export const isOffDayAllowed = (readiness) =>
  Boolean(readiness?.day_type && readiness.day_type !== "workday" && !failed(readiness.checks || [], "workday"));
